import { LAYOUTS, } from "@voltmoney/types";
import { amplitudeEventFinancialYear, amplitudeEventGetStatement, amplitudeEventPan, amplitudeEventPhone, amplitudeEventPrivacy, amplitudeEventTermsAndCondition, getStatementCtaAction, goBackAction, onChangeDimension } from "./actions";
import { StackType, StackWidth, WIDGET } from "@voltmoney/schema";
import sharedPropsService from "../../SharedPropsService";
import { ACTION } from "./types";
import { ROUTE } from "../../routes";
import { initializeFirebase } from "../../configs/config";
import { getTermsLinks, getPrivacyLinks } from "../../configs/utils";
import uuid from "react-native-uuid";
import { triggerAmplitudeEventCGS } from "./utils";
import moment from "moment";
import { config } from "../../configs/api";
export const template = (height, cgtcUserData, fyData, termsLink, privacyLink, unique_id) => ({
    layout: {
        id: ROUTE.CGTC_INIT,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true,
        },
        widgets: [
            { id: 'cgtcInitRootContainer', type: WIDGET.STACK },
        ],
    },
    datastore: {
        cgtcInitRootContainer: {
            type: StackType.column,
            width: StackWidth.MATCH_PARENT,
            widgetItems: [
                { id: 'cgtcInitPage', type: WIDGET.CGTC_INIT }
            ],
            dimensionAction: {
                type: ACTION.ON_CHANGE_DIMENSION,
                routeId: ROUTE.CGTC_INIT,
                payload: {}
            }
        },
        cgtcInitPage: {
            show: true,
            cgtcUserData: cgtcUserData,
            fyData: fyData,
            termsLink: termsLink,
            privacyLink: privacyLink,
            amplitudeEventPanAction: {
                routeId: ROUTE.CGTC_INIT,
                type: ACTION.AMPLITUDE_PAN,
                payload: {}
            },
            amplitudeEventPhoneAction: {
                routeId: ROUTE.CGTC_INIT,
                type: ACTION.AMPLITUDE_PHONE,
                payload: {}
            },
            amplitudeEventFinancialYearAction: {
                routeId: ROUTE.CGTC_INIT,
                type: ACTION.AMPLITUDE_FY,
                payload: {}
            },
            amplitudeEventTandCAction: {
                routeId: ROUTE.CGTC_INIT,
                type: ACTION.AMPLITUDE_T_AND_C,
                payload: {}
            },
            amplitudeEventPrivacyAction: {
                routeId: ROUTE.CGTC_INIT,
                type: ACTION.AMPLITUDE_PRIVACY,
                payload: {}
            },
            getStatementAction: {
                type: ACTION.GET_STATEMENT,
                routeId: ROUTE.CGTC_INIT,
                payload: {
                    unique_id: unique_id
                }
            }
        }
    },
});
export const cgtcInitMF = {
    onLoad: async ({ getHeight, network, navigateToBase, removeWidgets, initializeAmplitude, initializeAmplitudeWithDeviceID, instrumentTrack, ...props }) => {
        await initializeFirebase();
        await initializeAmplitude('', config.AMPLITUDE_CONFIG);
        await removeWidgets(ROUTE.CGTC_INIT, [
            { id: 'cgtcInitRootContainer', type: WIDGET.STACK },
            { id: 'cgtcInitPage', type: WIDGET.CGTC_INIT }
        ]);
        const termsLink = getTermsLinks();
        const privacyLink = getPrivacyLinks();
        const cgtcUserData = await sharedPropsService.getCgtcUserContext();
        if (cgtcUserData && cgtcUserData.toDate) {
            const toYear = cgtcUserData?.toDate.substring(7);
            if (toYear === `${moment().year()}`) {
                await sharedPropsService.setCgtcUserContext({
                    ...cgtcUserData,
                    toDate: `${moment().format('DD-MMM-YYYY')}`
                });
            }
        }
        if (cgtcUserData?.cgsData) {
            await navigateToBase(ROUTE.CGTC_SUMMARY);
        }
        const unique_id = uuid.v4();
        await initializeAmplitudeWithDeviceID(`${unique_id}`);
        await triggerAmplitudeEventCGS(instrumentTrack, {
            eventName: 'CGS_PAGE_VIEWED'
        });
        const fyData = JSON.parse(sharedPropsService.getFirebaseConfig().capital_gain_financial_year)?.data;
        return Promise.resolve(template(getHeight(), cgtcUserData, fyData, termsLink, privacyLink, `${unique_id}`));
    },
    actions: {
        [ACTION.GO_BACK]: goBackAction,
        [ACTION.ON_CHANGE_DIMENSION]: onChangeDimension,
        [ACTION.GET_STATEMENT]: getStatementCtaAction,
        [ACTION.AMPLITUDE_PAN]: amplitudeEventPan,
        [ACTION.AMPLITUDE_PHONE]: amplitudeEventPhone,
        [ACTION.AMPLITUDE_FY]: amplitudeEventFinancialYear,
        [ACTION.AMPLITUDE_T_AND_C]: amplitudeEventTermsAndCondition,
        [ACTION.AMPLITUDE_PRIVACY]: amplitudeEventPrivacy,
        [ACTION.AMPLITUDE_GET_STATEMENT]: amplitudeEventGetStatement,
    },
    clearPrevious: true,
};
